import React from 'react';

type Props = {
  className?: string;
  title?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
  tabIndex?: 0 | -1;
  ref?: React.Ref<SVGElement>;
};

const LinkIconSVG = ({className, ariaHidden, ariaLabel, tabIndex}: Props) => {

  return (
    <svg
      className={className}
      aria-hidden={ariaHidden}
      role={ariaHidden ? undefined : 'img'}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      xmlSpace="preserve"
    >
      <defs>
        <style>
          {`
            .cls-1 {
              fill: #16214c;
            }
        `}
        </style>
      </defs>
      <path id="Path_1" className="cls-1" d="M4.21,8.56l-2.57,2.57c-2.19,2.19-2.19,5.74,0,7.93,2.19,2.19,5.74,2.19,7.93,0l3.42-3.42c2.19-2.19,2.19-5.74,0-7.93-.45-.45-.97-.82-1.55-1.1l-1.1,1.1c-.11.11-.21.24-.29.37,1.99.57,3.13,2.64,2.56,4.63-.18.61-.5,1.16-.95,1.61l-3.42,3.42c-1.46,1.46-3.83,1.46-5.29,0-1.46-1.46-1.46-3.83,0-5.29l1.49-1.48c-.21-.78-.29-1.6-.24-2.41h0Z"/>
      <path id="Path_2" className="cls-1" d="M7.71,5.06c-2.19,2.19-2.19,5.74,0,7.93.45.45.97.82,1.55,1.1l1.45-1.45c-1.99-.54-3.18-2.59-2.64-4.58.17-.63.5-1.21.96-1.67l3.42-3.42c1.44-1.48,3.81-1.51,5.29-.07,1.48,1.44,1.51,3.81.07,5.29-.02.02-.05.05-.07.07l-1.48,1.48c.21.78.29,1.6.24,2.41l2.56-2.56c2.19-2.19,2.19-5.74,0-7.93-2.19-2.19-5.74-2.19-7.93,0l-3.42,3.42Z"/>
    </svg>
  );
};

export const LinkIcon = React.forwardRef<SVGElement, Props>(
  (props, forwardRef) => <LinkIconSVG {...props} ref={forwardRef} />,
);
